<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf" style="font-style: normal;"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span><span class="sm">FOR</span> <span class="sm">MY</span> <span class="sm">MOTHER</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-elliott-democracy-0005.vue?b3fcdbf2